module.exports = __webpack_public_path__ + "fonts/400-normal-greek.06dcf6e.woff2";